/*
all the documents sections in the order they should be displayed
change this order to change the order of the sections as they appear in the page
 */
import {ArrowUpTrayIcon, PlusIcon} from "@heroicons/react/24/outline";

export const sectionsOrder = [
	'configurations',
	'designs',
	// 'services',  // TODO uncomment this when services of type "service" are going to be public
	'users_documents',
	'products',
	'quotations_attachments',
	'worksite_images_and_notes_attachments',
	'tasks_images_and_reports',
]

/*
use enums for products documents grouping
 */
export const prodGrouping = {
	PRODUCT: "product",
	DOCUMENT_TYPE: "document_type",
}

export const SECTIONS_PLACEHOLDERS = {
	users_documents: {
		descriptionKey: "user_documents_description",
		actionIcon: PlusIcon,
		actionTextKey: "add_group",
		backgroundClass: "bg-ivory",
	},
	users_documents_content: {
		descriptionKey: "user_documents_content_description",
		actionIcon: ArrowUpTrayIcon,
		actionTextKey: "upload_documents",
		backgroundClass: "bg-ivory",
	},
	configurations: {
		titleKey: "no_configurations_title",
		descriptionKey: "no_surveys_description",
	},
	designs: {
		titleKey: "no_designs_title",
		descriptionKey: "no_surveys_description",
	},
	// services: {
	// 	titleKey: "no_services_title",
	// 	descriptionKey: "no_services_description",
	// },  // TODO uncomment this when services of type "service" are going to be public
	products: {
		descriptionKey: "no_products_description",
	},
	product_technical_sheet_list: {
		titleKey: "no_technical_sheets_title",
		descriptionKey: "no_technical_sheets_description",
	},
	product_video_list: {
		titleKey: "no_videos_title",
		descriptionKey: "no_videos_description",
	},
	task_images: {
		titleKey: "no_task_images_title",
		descriptionKey: "no_task_images_description",
	},
	task_reports: {
		titleKey: "no_task_reports_title",
		descriptionKey: "no_task_reports_description",
	},
	worksite_images: {
		titleKey: "no_worksite_images_title",
		descriptionKey: "no_worksite_images_description",
	},
	worksite_notes_attachments: {
		titleKey: "no_worksite_notes_attachments_title",
		descriptionKey: "no_worksite_notes_attachments_description",
	},
};

export const maxSize = 10000000;